import React from "react";
import Section from "../ui/Section/Section";
import { Grid } from "../ui/Grid/Grid";
import ChartCard from "../ui/Card/ChartCard";
import GaugeStat from "../ui/GaugeStat/GaugeStat";
import MiniMetric from "../ui/MiniMetric/MiniMetric";
import DeltaValue from "../ui/DeltaValue/DeltaValue";
import { SECTIONS } from "../../constants";

const { id, title } = SECTIONS.engagement;

const EngagementSection = ({ data }) => {
    return (
        <Section id={id} title={title}>
            <Grid cols={3}>
                <ChartCard title="eNPS">
                    <GaugeStat
                        pct={(data.enps + 100) / 2}
                        sub="score −100 à +100"
                        value={
                            <DeltaValue section={id} seed="enps">
                                +{data.enps}
                            </DeltaValue>
                        }
                    />
                    <MiniMetric
                        mt="12px"
                        label="Promoteurs"
                        value={
                            <DeltaValue section={id} seed="promoteurs" isPct>
                                {data.promoteurs}%
                            </DeltaValue>
                        }
                    />
                    <MiniMetric
                        label="Détracteurs"
                        value={
                            <DeltaValue section={id} seed="detracteurs" isPct>
                                {data.detracteurs}%
                            </DeltaValue>
                        }
                    />
                </ChartCard>
            </Grid>
        </Section>
    );
};

export default EngagementSection;
